import { Slot } from "radix-ui";
import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";

type Appearance = {
  variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link" | undefined;
  size?: "default" | "xs" | "sm" | "lg" | "icon" | "icon-xs" | "icon-sm" | "icon-lg" | undefined;
  className?: string | undefined;
};
export function buttonVariants({
  variant = "default",
  size = "default",
  className,
}: Appearance = {}) {
  return cn("cyra-button", `cyra-button--${variant}`, `cyra-button-size--${size}`, className);
}
export function Button({
  asChild = false,
  variant,
  size,
  className,
  type = "button",
  ...props
}: ComponentProps<"button"> & Appearance & { asChild?: boolean }) {
  const Control = asChild ? Slot.Root : "button";
  return (
    <Control
      {...props}
      type={asChild ? undefined : type}
      data-slot="button"
      className={buttonVariants({ variant, size, className })}
    />
  );
}
